export const MICE_ACTION_CONSTANTS = {
	SHOW_MODAL: 'SHOW_MODAL',
	POST_DATA: 'POST_DATA',
	HOTEL_SEARCH_DATA: 'HOTEL_SEARCH_DATA',
	UPDATE_FILTER_SEARCH_DATA: 'UPDATE_FILTER_SEARCH_DATA',
	UPDATE_SSR: 'UPDATE_SSR',
	UPDATE_SELECTED_HOTEL_DATA: 'UPDATE_SELECTED_HOTEL_DATA',
	SERVER_DEFAULT_DATA: 'SERVER_DEFAULT_DATA'
};
